export default __webpack_public_path__ + "static/Andrii-e8eff01dc342efa463d2693e69b225e6.jpeg";